import React, { Component } from 'react';
import './Header.css';
import GlobalMenu from "./GlobalMenu";
class Header extends Component {


    _getKey()
    {
        let re= new RegExp('key=(.*?)(&|$)')
        let param=window.location.search
        let keystring=''
        if(re.test(param))
        {
            keystring=decodeURI( param.match(re)[1])
        }
        return keystring;
    }

    _getHeader()
    {
        return (
            <div className='header'>
                <div className='header-row'>
                    <div className='header-items'>
                        <input type="file"  onChange={(e)=>{this.props.open(e)}}></input>
                    </div>
                    <div className='header-items'>
                        <a href={this.props.downloadLink} className="header-items-a" download="treemindmap.tmm">Download</a>
                    </div>
                    <div className='header-items'>
                        <a href="https://3yaa3yaa.netlify.app"  className="header-items-a" >About Developer</a>
                    </div>
                </div>
                <div className='header-margin'></div>
                </div>
        )
    }

    render() {
        return (
                this._getHeader()
        );
    }
}

export default Header;
